export const validateFormField = (fieldName, value) => {
    const errors = {};

    switch (fieldName) {
        case 'email': {
            const emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
            errors.email = emailValid ? null : 'Please enter a valid email';
            break;
        }
        case 'firstName': {
            const firstNameValid = value.length >= 2;
            errors.firstName = firstNameValid ? null : 'The field is required and the field must be at least 2 characters';
            break;
        }
        case 'lastName': {
            const lastNameValid = value.length >= 2;
            errors.lastName = lastNameValid ? null : 'The field is required and the field must be at least 2 characters';
            break;
        }
        default:
            break;
    }

    return errors;
};
